
import { apiSlice } from './apiSlice';
const USERS_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1`;

export const paymentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
       getDailySales: builder.query({
      query: (data) => ({
        url: `${USERS_URL}/payment/getdailysales`,
        method: 'get',
        credentials: "include",
      }),
    }),
    saveBankDetails: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/payments/save-bank-details`,
        method: 'POST',
        body: data,
        credentials: "include",
      }),
    }),
      getweeklysales: builder.query({
      query: (data) => ({
        url: `${USERS_URL}/payment/getweeklysales`,
        method: 'get',
        credentials: "include",
      }),
    }),

   getMyTotalBalance: builder.query({
      query: () => ({
        url: `${USERS_URL}/payments/get-total-balance`,
        method: 'get',
        credentials: "include",
      }),
    }),
      getWalletHistory: builder.query({
      query: () => ({
        url: `${USERS_URL}/payments/get-wallet-history`,
        method: 'get',
        credentials: "include",
      }),
    }),
      withdrawMoney: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/payments/withdrawMoney`,
        method: "POST",
        body: data,
        credentials: "include",

      }),
    }),
      getWalletTransaction: builder.query({
      query: () => ({
        url: `${USERS_URL}/payments/wallet-transaction`,
        method: 'get',
        credentials: "include",
      }),
    }),
  
  }),
});

// Export hooks for usage in components
export const {
useGetDailySalesQuery,useWithdrawMoneyMutation,useGetWalletTransactionQuery,
useGetweeklysalesQuery,useSaveBankDetailsMutation,useGetMyTotalBalanceQuery,useGetWalletHistoryQuery
} = paymentApiSlice;
